import Callout from '~/components/callout';

import CartInterestSVG from '~/assets/svg/icons/cart-interest';
import styles from '../../../styles/components/callout.module.scss';

import { Title } from 'types';

export default function ActQuickCallout({ title }: { title: Title }) {
  if (title && title.copies !== 1) return null;

  return (
    <Callout
      title='Rare find!'
      message='Only 1 copy left.'
      small
      inline
      icon={<CartInterestSVG />}
      containerStyles={styles['no-padding']}
    />
  );
}
